import React, {Component} from "react";
import ModalWindow from "./ModalWindow";
import './RemoteSupport.css';

export default class RemoteSupport extends Component {

    constructor (props) {

        super(props);
        this.state = {
        };

    }

    getCode () {

        return (
            <div className="connectForm">
                <iframe
                    className="remoteContainer"
                    scrolling="auto"
                    src="https://oec.screenconnect.com/"
                />
            </div>
        );

    }

    render () {

        return (
            <div>
                <ModalWindow
                    modalBody={this.getCode()}
                    modalId="remoteSupport"
                    modalSize="modal-lg"
                    modalTitle="Remote Support"
                />
            </div>
        );

    }

}
